const MainFunction = function TopBar({ logo, title, ChangeMonitoring }) { 
  const backgroundMainColor = 'rgb(12, 35, 64)';
  const titleColor= 'rgb(153, 255, 153)';

  function ChangeFullscreen() {
    if (document.fullscreenElement) {
      document.exitFullscreen();
      return;
    }

    const elem = document.documentElement;
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) { //Firefox
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) { //Chrome, Safari, Opera
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) { //IE/Edge
      elem.msRequestFullscreen();
    }
  }

  const buttonStyle = { 
    backgroundColor: backgroundMainColor, 
    color: 'rgb(204,204,204)', 
    border: 'none', 
    fontSize: 30, 
    width: 39, 
    height: 30, 
    cursor: 'pointer', 
    lineHeight: 1 
  };

  const textStyle = {
    fontWeight: 'bold', 
    textAlign: 'center', 
    lineHeight: 1
  };

  return (
    <div onContextMenu={(event)=>{ event.preventDefault(); }} style={{ userSelect: 'none', width: '100vw', height: 60, backgroundColor: backgroundMainColor }}>
      <div style={{ backgroundColor: backgroundMainColor, paddingTop: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ position: 'absolute', left: 30, top: 10}}>
          {/*!ChangeMonitoring ? logo : <div></div>*/}
          {logo}
        </div>

        <div style={{ width: 45, height: 36, margintLeft: 30 }}></div>

        <div style={{ ...textStyle, color: titleColor, fontSize: 40, height: 40, marginLeft: ChangeMonitoring ? 45 : 0 }}>
          {title}
        </div>

        <div style={{ marginRight: 30, display: 'flex' }}>
          {ChangeMonitoring && <button onClick={ChangeMonitoring} style={{ ...buttonStyle, fontSize: 25, lineHeight: 1.3, fontWeight: 'bold' }}>▷</button>}
          <button title={document.fullscreenElement ? '최소화' : '최대화'} onClick={ChangeFullscreen} style={buttonStyle}>◱</button>
        </div>
      </div>
    </div>
  );
}

export default MainFunction;